module.exports = __webpack_public_path__ + "static/media/texas.72109217.svg";